(function () {
  function fillMissingAlts() {
    document.querySelectorAll('img').forEach(function (img) {
      if (img.alt && img.alt.trim() !== '') return;
      var src = img.currentSrc || img.src || '';
      if (!src) return;
      try {
        var path = new URL(src, location.href).pathname;
        var filename = path.split('/').pop() || '';
        filename = filename.split('?')[0];
        filename = filename.replace(/\.[^.]+$/, '');
        filename = decodeURIComponent(filename)
          .replace(/[-_]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        if (filename) img.alt = filename;
      } catch (e) { }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillMissingAlts);
  } else {
    fillMissingAlts();
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'IMG') fillMissingAlts();
        else if (node.querySelectorAll && node.querySelectorAll('img').length) fillMissingAlts();
      }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
